import UIToggle from 'UIComponents/input/UIToggle';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAwayMode } from '../operators/getters';
import AvailabilityIndicator from './AvailabilityIndicator';
import { AgentStatusWorkingHoursPromptGated } from '../../prompts/components/AgentStatusWorkingHoursPromptGated';
import AgentStatusDropdown from './AgentStatusDropdown';
import { OutOfOfficeLabel } from './OutOfOfficeLabel';
import { WorkingHoursToggleTooltip } from './WorkingHoursToggleTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getStatusMessage = isAwayMode => {
  const common = {
    'data-test-id': 'agent-status-text',
    'data-test-isAvailable': !isAwayMode
  };
  return isAwayMode ? /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, common, {
    message: "routing-ui.agent-status.agentIsAway"
  })) : /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, common, {
    message: "routing-ui.agent-status.agentIsAvailable"
  }));
};
const AgentStatusToggle = ({
  agentStatus,
  updateAwayMode,
  atCapacity,
  hasAvailabilityStatusEditAccess,
  isUngatedForHelpDeskRoutingScopeFiltering,
  isUngatedForWorkingHours,
  isUngatedForOutOfOffice,
  userId
}) => {
  const isAwayMode = Boolean(getAwayMode(agentStatus));
  const onAwayModeToggle = () => {
    const nextAwayModeState = !getAwayMode(agentStatus);
    updateAwayMode(nextAwayModeState);
  };
  return isUngatedForHelpDeskRoutingScopeFiltering && !hasAvailabilityStatusEditAccess ? /*#__PURE__*/_jsx(AgentStatusDropdown, {
    agentStatus: agentStatus,
    atCapacity: atCapacity
  }) : /*#__PURE__*/_jsxs("span", {
    className: "flex-row width-100 align-center justify-between p-x-2",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-column",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "display-inline-flex align-center",
        children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
          isAwayMode: isAwayMode,
          atCapacity: atCapacity
        }), getStatusMessage(isAwayMode)]
      }), isUngatedForOutOfOffice && /*#__PURE__*/_jsx(OutOfOfficeLabel, {
        userId: userId
      })]
    }), /*#__PURE__*/_jsx(AgentStatusWorkingHoursPromptGated, {
      userId: userId,
      isAway: isAwayMode,
      isUngatedForWorkingHours: isUngatedForWorkingHours,
      children: /*#__PURE__*/_jsx(WorkingHoursToggleTooltip, {
        userId: userId,
        isUngatedForOutOfOffice: isUngatedForOutOfOffice,
        children: /*#__PURE__*/_jsx(UIToggle, {
          className: "m-left-2",
          checked: !isAwayMode,
          "data-test-id": "agent-status-toggle",
          size: "extra-small",
          onChange: onAwayModeToggle
        })
      })
    })]
  });
};
AgentStatusToggle.displayName = 'AgentStatusToggle';
export default AgentStatusToggle;